import { createTheme } from "@mui/material/styles";
import {
  COLOR_PRIMARY,
  COLOR_PRIMARY_DARK,
  COLOR_PRIMARY_LIGHT,
  COLOR_SECONDARY,
  COLOR_GREY_100,
  COLOR_GREY_300,
  BORDER_RADIUS,
} from "./colors";

/** @deprecated Import named constants from ./colors instead */
export const colors = {
  primary: COLOR_PRIMARY,
  primaryDark: COLOR_PRIMARY_DARK,
  primaryLight: COLOR_PRIMARY_LIGHT,
  secondary: COLOR_SECONDARY,
  grey: {
    100: COLOR_GREY_100,
    300: COLOR_GREY_300,
  },
};

const theme = createTheme({
  palette: {
    primary: {
      main: COLOR_PRIMARY,
      dark: COLOR_PRIMARY_DARK,
      light: COLOR_PRIMARY_LIGHT,
      contrastText: "#ffffff",
    },
    secondary: {
      main: COLOR_SECONDARY,
      contrastText: "#1a1000",
    },
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  shape: {
    borderRadius: BORDER_RADIUS,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          letterSpacing: 0,
        },
        containedPrimary: {
          boxShadow: "0 4px 12px rgba(0, 163, 196, 0.3)",
          "&:hover": {
            boxShadow: "0 6px 16px rgba(0, 163, 196, 0.4)",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: BORDER_RADIUS,
        },
      },
    },
  },
});

export default theme;

